import styled from 'styled-components';
import { ReactComponent as Eye } from 'Images/showHide.svg';
import { ReactComponent as EyeSlash } from 'Images/eyeSlash.svg';

export const ToggleButton = styled.button`
  position: absolute;
  right: 13px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  line-height: 0;
`;
ToggleButton.displayName = 'ToggleButton';

const iconStyles = `
  width: 14px;
  height: 10px;
  & > path {
    fill: currentColor;
  }
`;

export const ShowIcon = styled(Eye)`
  ${iconStyles}
  color: ${({ theme }) => theme.icons.actionBar.color};
`;
ShowIcon.displayName = 'ShowIcon';

export const HideIcon = styled(EyeSlash)`
  ${iconStyles}
  color: ${({ theme }) => theme.icons.actionBar.color};
`;
HideIcon.displayName = 'HideIcon';
